import axios from 'axios';
// import { Toast } from 'vant';
import {setBaseUrl, setTokenFromCookie} from '@/utils/tools';
// eslint-disable-next-line import/no-cycle
import router from '@/router';
import store from '../store';

// 取消重复请求
const pending = [];
const {CancelToken} = axios;
axios.defaults.baseURL = setBaseUrl();
// axios.defaults.baseURL = '/';
axios.defaults.timeout = 15 * 1000; // 15s

function cancel(config) {
  if (config && config.url && config.method) {
    const id = `${config.url}&request_type=${config.method}`;
    pending.some((item) => {
      if (new RegExp(item.url).test(id)) {
        // 执行取消操作
        // item.cancel();
        // 从数组中移除记录
        // pending.splice(index, 1);
        return true;
      }
      return false;
    });
  }
}

// 添加一个请求拦截器
axios.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么
    // alert('send requst');
    const configCopy = config;
    const token = window.localStorage.getItem('accessToken');
    // alert(token);
    if (token && String(token) !== '(null)') {
      // 将token放到请求头发送给服务器,将tokenkey放在请求头中
      configCopy.headers.Authorization = `Bearer ${token}`;
    }
    // cancel(configCopy);
    configCopy.cancelToken = new CancelToken((c) => {
      pending.push({
        url: `${configCopy.url}&request_type=${configCopy.method}`,
        cancel: c,
      });
    });
    // alert(configCopy.url);
    return configCopy;
  },
  (error) => Promise.reject(error), // 对请求错误做些什么
);
// 添加响应拦截器
axios.interceptors.response.use(
  (res) => {
    return res
  },
  (error) => {
    let message = '网络错误：';
    if (error.response) {
      const {status} = error.response;
      message += status;
      if (error.response.status === 401) { // 401且登录弹窗未显示
        window.localStorage.removeItem('accessToken');
        store.dispatch('saveUserInfo', {});
      }
      if (status === 401) {
        if (window.navigator.userAgent.toLowerCase().includes('iqihang')) {
          this.$sendToApp('login', {}, true).then(async () => {
            setTokenFromCookie();
          });
        } else if (router.currentRoute.meta.requireAuth) {
          router.push({
            path: '/registrationLogin',
            query: {redirect: router.currentRoute.fullPath}, // 将跳转的路由path作为参数，登录成功后跳转到该路由
          });
        }
      }
    } else if (error.request) {
      message += error.message;
    } else {
      message = `程序错误：${error.message}`;
    }
    // if (String(error) === 'Error: Network Error' && process.env.NODE_ENV !== 'development') {
    //   Toast('无可用网络，请检查您的网络');
    // }
    return Promise.reject(new Error('程序错误'));
    // return Promise.resolve(new Error(message));
  },
);

export default function ajax(url, data = {}, method = 'GET', config) {
  // console.log(data);

  return new Promise((resolve, reject) => {
    let result;
    let queryStr = '';
    let urlCopy = url;
    switch (method) {
      case 'GET':
        Object.keys(data).forEach((item) => {
          const value = data[item];
          queryStr += `${item}=${value}&`;
        });
        if (queryStr) {
          queryStr = queryStr.substring(0, queryStr.length - 1);
          urlCopy += `?${queryStr}`;
        }
        result = axios.get(urlCopy, config);
        break;
      case 'DELETE':
        result = axios.delete(url, {data});
        break;
      case 'PUT':
        result = axios.put(url, data, config);
        break;
      default:
        result = axios.post(url, data, config);
    }
    result
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
